const pinnedKeys: Record<string, string> = {};
let defaultPinnedKeyId: string | null = null;

export function setPinnedKey(keyId: string, base64: string): void {
  pinnedKeys[keyId] = base64;
}

export function setDefaultPinnedKey(base64: string, keyId = 'default'): void {
  pinnedKeys[keyId] = base64;
  defaultPinnedKeyId = keyId;
}

export function getPinnedKeyBase64(keyId: string): string | null {
  return pinnedKeys[keyId] ?? null;
}

export function getDefaultPinnedKeyBase64(): string | null {
  if (defaultPinnedKeyId == null) return null;
  return pinnedKeys[defaultPinnedKeyId] ?? null;
}
